import { type timeslotType, WorkPlaces } from "../types/types";

export const workPlaceMap: Record<WorkPlaces, string> = {
	[WorkPlaces.MSK]: "МСК",
	[WorkPlaces.SPB]: "СПБ",
	[WorkPlaces.OTHER]: "РЕГ",
};

export const fullCityNames: Record<WorkPlaces, string> = {
	[WorkPlaces.MSK]: "Москва",
	[WorkPlaces.SPB]: "Санкт-Петербург",
	[WorkPlaces.OTHER]: "Регионы",
};

export const typesMap: Record<timeslotType | string, string> = {
	SR: "СР",
	Dost: "Доставка",
	Vid: "Выдача",
	PZ: "ПЗ",
	PXD: 'ПХД',
	TO: 'ТО'
};

export const installerPointNumber: Record<string, string> = {
	"0": "A",
	"1": "B",
	"2": "C",
	"3": "D",
	"4": "E",
	"5": "F",
};
